// @ts-ignore
import axios, { AxiosRequestConfig, AxiosResponse } from '@/helpers/api/HTTPClient.helper';

const DEFAULT_API_VERSION: string = import.meta.env.VITE_API_VERSION;
const BASE_URL: string = import.meta.env.VITE_API_BASE_URL;

interface ApiClientOptions {
  apiVersion?: string;
}

class ApiClient {
  private apiVersion: string;
  private resource: string;
  private options: ApiClientOptions;

  constructor(resource: string, options: ApiClientOptions = {}) {
    this.apiVersion = options.apiVersion || DEFAULT_API_VERSION;
    this.options = options;
    this.resource = resource;
  }

  private get url(): string {
    return `${BASE_URL}/${this.apiVersion}/${this.resource}`;
  }

  get<T>(options: AxiosRequestConfig = {}, resource: string = ''): Promise<AxiosResponse<T>> {
    const handledResource = resource ? `/${resource}` : '';
    return axios.get(`${this.url}${handledResource}`, options);
  }

  show<T>(id: string | number, resource: string = ''): Promise<AxiosResponse<T>> {
    const handledResource = resource ? `/${resource}` : '';
    return axios.get(`${this.url}${handledResource}/${id}`);
  }

  create<T>(
    data: Record<string, any> = {},
    resource: string = '',
    params?: Record<string, any>,
    headers?: Record<string, any>,
  ): Promise<AxiosResponse<T>> {
    const handledResource = resource ? `/${resource}` : '';
    return axios.post(`${this.url}${handledResource}`, data, { params, headers });
  }

  update<T>(id: string | number, data: Record<string, any>): Promise<AxiosResponse<T>> {
    return axios.put(`${this.url}/${id}`, data);
  }

  patch<T>(id: string | number, data: Record<string, any>): Promise<AxiosResponse<T>> {
    return axios.patch(`${this.url}/${id}`, data);
  }

  delete<T>(id: string | number, resource: string = ''): Promise<AxiosResponse<T>> {
    const handledResource = resource ? `/${resource}` : '';
    return axios.delete(`${this.url}${handledResource}/${id}`);
  }
}

export default ApiClient;
